export default {
  title: '{{plan}} est actif',
  plan: 'Forfait : {{plan}}',
  free_until: "Gratuit jusqu'au {{date}}",
  continue: 'Continuer',
};
